import React, { useEffect } from 'react';
import {
  FiXCircle, FiAlertCircle, FiInfo, FiCheckCircle
} from 'react-icons/fi';

import { Container } from './styles';
import { ToastMessage, useToast } from '../../../hooks/toast';

interface ToastProps {
  message: ToastMessage;
  styles: object;
}

export const Toast: React.FC<ToastProps> = ({ message, styles }) => {
  const icon = {
    info: <FiInfo size={24} />,
    sucess: <FiCheckCircle size={24} />,
    error: <FiAlertCircle size={24} />
  };

  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id]);

  return (
    <Container type={message.type} hasDescription={!!message.description} style={styles}>
      {icon[message.type || 'info']}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button onClick={() => removeToast(message.id)} type="button">
        <FiXCircle size={18} />
      </button>
    </Container>
  );
};
